import request from 'utils/RequestManager';

import config from 'config';

const baseURL = config.GRAPH_HOST;
const fileUploadBaseURL = config.FILE_UPLOAD_HOST;

export function getCompany(clientId) {
  return request({
    method: 'GET',
    baseURL,
    url: `/companies/${clientId}`,
  }).then(res => res.data);
}

export function fetchGraph(id) {
  return request({
    method: 'GET',
    baseURL,
    url: `/trees/${id}`,
  }).then(res => res.data);
}

export function editButtonIndex(messageId, buttonId, newIndex) {
  return request({
    method: 'PUT',
    baseURL,
    url: `/buttons/index`,
    params: {
      messageId,
      buttonId,
      newIndex
    }
  }).then(res => res.data);
}

export function addNodeForButton(buttonId, tempNode) {
  return request({
    method: 'POST',
    baseURL,
    url: `/messages/relationships/${buttonId}`,
    data: tempNode.name,
  }).then(res => res.data);
}

export function editNode(node) {
  node.buttons.forEach((button, index) => {
    button.index = index;
  });
  return request({
    method: 'PUT',
    baseURL,
    url: '/messages',
    data: node,
  }).then(res => res.data);
}

export function connectEdgeToDestination(buttonId, destinationId) {
  return request({
    method: 'PUT',
    baseURL,
    url: `/messages/relationships/${buttonId}/${destinationId}`,
  }).then(res => res.data);
}

export function deleteNode(nodeId) {
  return request({
    method: 'DELETE',
    baseURL,
    url: `/messages/${nodeId}`,
  }).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/services/api.js